import { UIHeading5 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IAdvantageItemProps {
  title: string;
  imgUrl?: string;
  counter: number;
}

export function AdvantageItem({ title, imgUrl }: IAdvantageItemProps) {
  return (
    <div
      data-testid="NewbuildingAdvantages"
      className={styles['container']}
      style={{ backgroundImage: `url(${imgUrl})` }}
    >
      <div className={styles['title']}>
        <UIHeading5 as="h3" color="text-inverted-default">
          {title}
        </UIHeading5>
      </div>
    </div>
  );
}
